import { Box, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import * as styles from "./howItWorks.css";
import * as commonStyles from "styles/common.css";
import Link from "next/link";

const HowItWorks = () => {
  return (
    <Box>
      <Typography
        variant="h2"
        fontSize="3rem"
        align="center"
        fontWeight="bold"
        sx={{ marginBottom: "4rem" }}
        className={styles.heading}
      >
        How it works?
      </Typography>
      <Grid container justifyContent="space-between" className={styles.wrapper}>
        <Paper className={styles.block}>
          <CloudUploadIcon fontSize="large" className={styles.icon} />
          <Typography className={styles.text}>
            Upload your CSV or similar file format. More information about file
            formatting can be found in the requirements section{" "}
            <Link href="/#requirements" className={commonStyles.link}>
              requirements
            </Link>{" "}
            section.
          </Typography>
        </Paper>
        <Paper className={styles.block}>
          <BackupTableIcon fontSize="large" className={styles.icon} />
          <Typography className={styles.text}>
            Map your data columns (e.g., `Date` and `Amount`) to our analytics
            fields using the dropdown menus. More information about analytics
            fields can be found on mapping page or on{" "}
            <Link href="/demo" className={commonStyles.link}>
              demo
            </Link>{" "}
            page.
          </Typography>
        </Paper>
        <Paper className={styles.block}>
          <InsertChartIcon fontSize="large" className={styles.icon} />
          <Typography className={styles.text}>
            Analyze your transactions through our interactive dashboard with
            insights and trends.
          </Typography>
        </Paper>
      </Grid>
    </Box>
  );
};

export default HowItWorks;
